import {
  SegmentActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
} from '@heidi/analytics/events';
import { getCurrentSessionId } from '@heidi/runtime/shell';

// Document
export function documentCreateClick() {
  trackLegacyEvent({
    name: SegmentObjectName.Document,
    props: {
      action: SegmentActionName.DocumentCreateClick,
    },
  });
}

export function documentCreatedByAICommand(aiCommandId?: string) {
  trackLegacyEvent({
    name: SegmentObjectName.Document,
    props: {
      action: SegmentActionName.DocumentCreatedByAICommand,
      aiCommandId: aiCommandId,
    },
  });
}

export function documentCreatedByAskAI(aiCommandText?: string) {
  trackLegacyEvent({
    name: SegmentObjectName.Document,
    props: {
      action: SegmentActionName.DocumentCreatedByAskAI,
      aiCommandText: aiCommandText,
    },
  });
}

export function documentCreatedByTemplate(templateId?: string) {
  trackLegacyEvent({
    name: SegmentObjectName.Document,
    props: {
      action: SegmentActionName.DocumentCreatedByTemplate,
      templateId: templateId,
    },
  });
}

export function documentSelectionCopyAll() {
  trackLegacyEvent({
    name: SegmentObjectName.Document,
    props: {
      action: SegmentActionName.DocumentSelectionCopyAll,
    },
  });

  // V2
  const sessionId = getCurrentSessionId();
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.DocumentCopied,
    props: {
      ...(sessionId != null && { session_id: sessionId }),
    },
  });
}

export function documentSyncChangesClicked() {
  trackLegacyEvent({
    name: SegmentObjectName.Document,
    props: {
      action: SegmentActionName.DocumentSyncChangesClicked,
    },
  });

  // V2
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.DocumentSynced,
    props: {},
  });
}

// Extracted from src/lib/analytics/scribe/document.ts; history: git log --follow src/lib/analytics/scribe/document.ts
// Note
export function noteSelectionRegenerateOutput() {
  trackLegacyEvent({
    name: SegmentObjectName.Document,
    props: {
      action: SegmentActionName.NoteSelectionRegenerateOutput,
    },
  });

  // V2
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.DocumentUpdated,
    props: {
      update_action: 'regenerate_output',
    },
  });
}
